<app-header></app-header>
<div id="main_app" class="container-fluid">
  <div class="container">
    <div class="ranking_title">{{ 'UserRatings' | translate }}</div>
    <div class="ranking_excerpt">{{ 'RankingInfo1' | translate }}</div>
    <div class="top_table">
      <div class="ranking_allow">
        <div class="ranking_allow_title" *ngIf="!isLoggedIn" (click)="openPopUp()">
        {{'YouMustFirstLogInToYourAccount'| translate}}
        </div>
        <div class="ranking_allow_title" *ngIf="isLoggedIn">
          {{'WantToBeInTheGeneralRankingOfUsers' | translate}}
        </div>
        <div class="ranking_allow_switch" *ngIf="isLoggedIn">
                          <label class="switch" for="ranking">
                            <input type="checkbox" id="ranking"
                                   name="pomodoroRepository.beInPomodoroRanking"
                                   [(ngModel)]="setting.be_in_pomodoro_ranking"
                                   (change)="rankingUpdate(setting.be_in_pomodoro_ranking)">
                            <div class="slider round"></div>
                          </label>
          <mat-spinner style="margin: -24px 5px 0 0; vertical-align: middle; display: inline-block !important;stroke: #E0003E !important; background-color: #F5F5F5 !important;" matSuffix [diameter]="20" color="accent" *ngIf="loadSpinner"></mat-spinner>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="ranking_filter">
        <ul>
          <li (click)="onClickAllUserRank(4)" [ngClass]="{'active': allUserTab==='tab4'}">
            <a (click)="rankOfMonth()">{{ 'ThirtyDaysAgo' | translate }}</a>
          </li>
          <li (click)="onClickAllUserRank(3)" [ngClass]="{'active': allUserTab==='tab3'}">
            <a (click)="rankOfWeek()">{{ 'SevenDaysAgo' | translate }}</a>
          </li>
          <li (click)="onClickAllUserRank(2)" [ngClass]="{'active': allUserTab==='tab2'}">
            <a (click)="rankOfYesterday()">{{ 'Yesterday' | translate }}</a>
          </li>
          <li class="active" (click)="onClickAllUserRank(1)" [ngClass]="{'active': allUserTab==='tab1'}">
            <a (click)="rankOfToday()">{{ 'Today' | translate }}</a>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>
    <table class="ranking_table">
      <tr>
        <th>{{ 'Rank' | translate }}</th>
        <th>{{ 'UserInformation' | translate }}</th>
        <th>{{ 'DurationOfDoneTask' | translate }}</th>
        <th>{{ 'NumberOfPomodoros' | translate }}</th>
      </tr>
      <div class="spinner-line"><mat-spinner matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="spinner"></mat-spinner></div>
      <tr *ngFor="let item of mainRankModule | paginate: { itemsPerPage: 20, currentPage: p }; let i = index"
          [ngClass]="{'you_are': item.user_id == userId }">
<!--        <ng-container *ngIf="item.online_at != null && item.online_at < 25">-->
        <td *ngIf="p === 1">{{i + 1}}</td>
        <td *ngIf="p === 2">{{i + 21}}</td>
        <td *ngIf="p === 3">{{i + 41}}</td>
        <td *ngIf="p === 4">{{i + 61}}</td>
        <td>
          <div class="ranking_user_detail">
            <div class="ranking_user_avatar" matTooltipPosition="right" matTooltip="آنلاین" *ngIf="item.online_status === 'online'">
              <img src="{{item.profile_photo_url}}" alt="{{item.name}}" width="50px" height="45px">
              <div class="online_sign"></div>
            </div>
            <div class="ranking_user_avatar" matTooltipPosition="right" matTooltip="آفلاین" *ngIf="item.online_status === 'offline'">
              <img src="{{item.profile_photo_url}}" alt="{{item.name}}" width="50px" height="45px">
              <div class="offline_sign"></div>
            </div>
            <div class="ranking_user_avatar" matTooltipPosition="right" matTooltip="تازگیا آنلاین بوده" *ngIf="item.online_status === 'online Hour Ago'">
              <img src="{{item.profile_photo_url}}" alt="{{item.name}}" width="50px" height="45px">
              <div class="recently_sign"></div>
            </div>
            <div class="ranking_user_avatar" matTooltipPosition="right" matTooltip="در حال استراحت پومودورویی" *ngIf="item.online_status === 'resting'">
              <img src="{{item.profile_photo_url}}" alt="{{item.name}}" width="50px" height="45px">
              <div class="resting_sign"></div>
            </div>
            <div class="ranking_user_name">
              <ng-container *ngIf="item.name != null">
                {{item.name}}
              </ng-container>
              <ng-container *ngIf="item.name === null">
                بدون نام
              </ng-container>
            </div>
            <div class="clearfix"></div>
          </div>
        </td>
        <td>{{showMoment(item.sum_of_pomodoro_time)}}</td>
        <td>{{item.count_of_pomodoro}}
<!--          *<ng-container>{{item.online_at}}</ng-container></td>-->
<!--        <td>{{item.count_of_pomodoro}}</td>-->
<!--        </ng-container>-->
      </tr>
    </table>
    <div class="row mt-4 pagination-section" *ngIf="showPagination">
      <div class="col-4"></div>
      <pagination-controls [ngClass]="pomodoroRepository.darkMode ? 'dark-pagination' : 'my-pagination'" class="my-pagination col-4"
                           (pageChange)="p = $event"
                           previousLabel="{{ 'Previous' | translate }}"
                           nextLabel="{{ 'Next' | translate }}"
                           directionLinks="true"
      ></pagination-controls>
      <div class="col-4"></div>
    </div>
  </div><!-- .container -->
</div><!-- #main_app -->
<app-footer></app-footer>
